<script lang="ts">
  interface Props {
    nospace?: boolean;
    children?: import('svelte').Snippet;
  }

  let { nospace = false, children }: Props = $props();
</script>

<div class="comp-card" class:nospace>{@render children?.()}</div>

<style>
  .comp-card {
    background-color: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.07);
    border-radius: 2px;
    padding: 16px;
  }
  .comp-card.nospace {
    padding: 0;
  }
</style>
